import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Component({
    selector: 'send-admin-email',
    templateUrl: 'send-admin-email.component.html',
    styleUrls: ['send-admin-email.component.scss']
})
export class SendAdminEmailComponent {
    public userEmail: string;
    public EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    @ViewChild('sendEmailForm', { static: false}) sendEmailForm: ElementRef;

    constructor(private _router: Router,
        private _location: Location,
        private _autoLoginClient: AutoLoginClient,
        private _toastService: BzgToastService,
        private _translateService: TranslateService) {
    }

    public back() {
        this._location.back();
    }

    public sendEmail() {
        if (this.isEmailValid(this.sendEmailForm)) {
            this._autoLoginClient.login(this.userEmail, '').subscribe((response) => {
                if(!response || !response.autoLoginCodeMessage){
                    this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
                        this._toastService.open(
                            message,
                            {
                                type: 'error',
                                duration: 0,
                                verticalPosition: 'bottom',
                                horizontalPosition: 'right'
                            });
                    });
                }
                switch (response.autoLoginCodeMessage) {
                    case 'LoginUserMustChangePassword':
                        this._router.navigate(['email-sent']);
                        break;
                    case 'LoginWrongCredentials':
                        this._translateService.get('AUTOADMIN.WRONG_CREDENTIALS').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'SendVerificationCodeSMTPWrongConfiguration':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_WRONG_CONFIGURATION').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'SendVerificationCodeUnexpectedError':
                    case 'SendVerificationCodeMissingSMTPConfiguration':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_UNEXPECTED_ERROR').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    default:
                        this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                }
            });
        }
    }

    private isEmailValid(form): boolean {
        let isValid = true;
        if (!this.userEmail || this.userEmail === '' || form.form.controls.userEmailInput.invalid) {
            isValid = false;
        }
        return isValid;
    }
}
